export default {
  modalShowing: false,
  modalContent: undefined,
  userRoles: {}
}
